import { render, staticRenderFns } from "./AvailabilityIntervalsList.vue?vue&type=template&id=5b3e636c&scoped=true"
import script from "./AvailabilityIntervalsList.vue?vue&type=script&lang=js"
export * from "./AvailabilityIntervalsList.vue?vue&type=script&lang=js"
import style0 from "./AvailabilityIntervalsList.vue?vue&type=style&index=0&id=5b3e636c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3e636c",
  null
  
)

export default component.exports